/**
 * An object containing properties for copy events
 */
var CopyEvent = /** @class */ (function () {
    function CopyEvent() {
    }
    return CopyEvent;
}());
export { CopyEvent };
//# sourceMappingURL=copy-event.js.map